<template>
    <div class="big_box">
        <div class="img_55 title_center"></div>
        <div class="img_203 title_center" style="margin-bottom:0rem"></div>
        <div class="config_box">
            <div v-for="item,key in config"
                 :class="'img_nk_0 ico_bg cursor ' + (key==0?' img_nk_0 ':' img_nk_1 ')"
                 @click="down(item, key)">
                <div class="img_214 left_bottom " v-if="(item.item_id>0&&item.item_id<7)||item.item_id===0"></div>
                <div class="img_19 ico_img " v-if="item.lock"></div>
                <div :class="' ico_img ico_'+item.item_id" v-else></div>
                <div class="text_name" v-text="conf_name[item.item_id]"></div>
                <div class="img_32 update_alter"></div>
            </div>
        </div>
        <div class="img_56 title_center"></div>
        <!--        新提前排序        -->
        <div class="content_center" style="margin-top:0rem">
            <template v-for="is_show,key in is_new_arr">
                <div v-for="item,key in show_all_config"
                     :class="'ico_bg ico_'+item.item_id+(item.now_number && is_max(item)?' cursor ':' not_click')"
                     @click="up(item, key)" v-show="(new_data[item.item_id]||'') == (is_show||'')">
                    <div class="img_214 left_bottom " v-if="(item.item_id>0&&item.item_id<7)||item.item_id===0"></div>
                    <div class="right_top">
                        <div class="img_66 " v-if="new_data[item.item_id]"></div>
                    </div>
                    <div class="right_bottom">
                        <div class="img_96 show_number_box" v-if="item.now_number" v-text="'数量X'+item.now_number"></div>
                    </div>
                    <div :class="' ico_img '+item.item_id"></div>
                    <div class="text_name" v-text="conf_name[item.item_id]"></div>
                    <div class="img_61 update_alter"></div>
                </div>
            </template>


        </div>
    </div>
</template>

<script>
module.exports = {
    props: ['data'],
    data() {
        return {
            role_is_max : true,
            goods_is_max: true,
            user        : {},
            new_data    : {},
            is_new_arr :[1,''],
            all_config  : [
                {item_id: 0, now_number: 0, number: 0},
                {item_id: 1, now_number: 0, number: 0},
                {item_id: 2, now_number: 0, number: 0},
                {item_id: 3, now_number: 0, number: 0},
                {item_id: 4, now_number: 0, number: 0},
                {item_id: 5, now_number: 0, number: 0},
                {item_id: 6, now_number: 0, number: 0},
                {item_id: 7, now_number: 0, number: 0},
                {item_id: 8, now_number: 0, number: 0},
                {item_id: 9, now_number: 0, number: 0},
                {item_id: 10, now_number: 0, number: 0},
                {item_id: 11, now_number: 0, number: 0},
                {item_id: 12, now_number: 0, number: 0},
                {item_id: 13, now_number: 0, number: 0},
            ],


        }
    },
    computed: {
        show_all_config() {
            return this.all_config.filter(i => i.number)
        },
        config() {
            return (this.data || {}).config || []
        },
    },
    created() {
        this.new_data = {}
        if (this.data.new_role_list) {
            //     加新好
            this.data.new_role_list.forEach(i => this.new_data[i] = 1)
        }
        this.user = this.user_data
        this.get_data()
        this.update_is_max()
    },
    methods: {
        update_is_max() {
            this.role_is_max = this.config.filter((i, index) => !i.lock && index == 0 && (i.item_id === null || i.item_id === undefined || i.item_id === '')).length
            this.goods_is_max = this.config.filter((i, index) => !i.lock && index > 0 && (i.item_id === null || i.item_id === undefined || i.item_id === '')).length
        },
        is_max(item) {
            return item && item.item_id < 7 ? this.role_is_max : this.goods_is_max
        },
        down(item, key) {
            if (item && item.lock) {
                return this.$top_box.show_box('累计完成三日签到或完成一次邀请任务可解锁舱位')
            }
            var item_id = this.config[key].item_id
            if (item_id === undefined || item_id === null || item_id === '') {
                return
            }
            console.log('dd', item_id, this.config[key])
            var arr = this.all_config.filter(i => i.item_id == item.item_id)

            arr[0] && arr[0].now_number++
            this.config[key].item_id = null
            this.update_config()
        },
        up(item, key) {
            var item_data
            if (item.item_id < 7) {
                item_data = this.config.filter((i, index) => !i.lock && index == 0 && (i.item_id === null || i.item_id === undefined || i.item_id === ''))
            } else {
                item_data = this.config.filter((i, index) => !i.lock && index > 0 && (i.item_id === null || i.item_id === undefined || i.item_id === ''))
            }


            if (!(item.now_number && this.is_max)) {
                return
            }
            if (item_data.length == 0) {
                return
            }
            item.now_number--
            item_data[0].item_id = item.item_id
            this.update_config()

        },
        update_config() {
            this.update_is_max()
            var that = this
            var item_ids = this.config.map(i => {
                return {item_id: (i.item_id === undefined || i.item_id === null) ? '' : i.item_id.toString()}
            })

            this.$httpr.update_config(item_ids, function (err, result) {
                err = err || result.err || result.msg
                if (err) {
                    return that.$alter_err.show_box('err', err)
                }
            })
        },
        get_data() {
            var that = this
            this.$httpr.select_config(function (err, result) {
                err = err || result.err || result.msg
                if (err) {
                    return that.$alter_err.show_box('err', err)
                }
                var data = result.data

                that.all_config = data.all_config.map((i, item_id) => {
                    return {item_id, number: i, now_number: i}
                })

                // that.config = (data.now_config || '').split(',')
                that.config.forEach(i => {
                    var item_id = i.item_id
                    if (item_id || item_id === 0) {
                        that.all_config[item_id] && that.all_config[item_id].now_number--
                    }
                })
            })
        },
    }
}
</script>

<style scoped>
.content_text {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    text-align: center;
    transform: translate(-50%, -50%);
    font-size: 0.36rem;
    color: #000000;
}

.config_box {
    width: 100%;
    text-align: center;
    top: 3rem;
}

.ico_bg {
    position: relative;
    display: inline-block;
    width: 1.4rem;
    height: 2.1rem;
    margin: 0.2rem;
}

.right_top {
    position: absolute;
    right: -.1rem;
    top: -.1rem;
    z-index: 1;
}

.right_bottom {
    position: absolute;
    right: -.1rem;
    top: 1.2rem;
    z-index: 1;
    font-size: .14rem;
}

.not_click {
    opacity: .5;
}

.update_alter {
    position: absolute;
    bottom: 0rem;
    left: 0.2rem;
    /*width: 1.38rem;*/
}

.text_name {
    position: absolute;
    top: 1.55rem;
    text-align: center;
    transform: translate(0%, -50%);
    font-size: 0.15rem;
    width: 100%;
    /*width: 1.38rem;*/
}

.ico_img {
    position: absolute;
    width: 100%;
    height: 100%;
}

.progressBar {
    margin-top: 0.1rem;
}


.rule_button {
    position: absolute;
    left: 0.0rem;
    top: 1.2rem;
}

.show_number_box {
    color: #d9d8d6;
    font-size: 0.12rem;
    text-align: center;
    line-height: .23rem;
}

.show_number {
    color: #FFFFFF;
    font-size: 0.2rem;
    text-align: center;
    line-height: .50rem;
}

.left_bottom{
    position: absolute;
    left:-.1rem;
    top:1.1rem;
    z-index:2;
}
.content_center {
    width: 91%
}

</style>